<template>
    <div class="de-arrow-percent">
        <h2-title class="title" :title="title" :font-obj="titleFontObj" :paddingLeft="titlePaddingLeft" :lineHeight="titleLineHeight"></h2-title>
        <p class="num" :style="sumStyleObj">{{sum | formatAmount}}
            <span>
                <span class="arrow" :style="selfArrowStyle"></span>
                <span class="percent" :style="selfPercentStyle">{{Math.abs(percent)}}%</span>
            </span>
        </p>
    </div>
</template>

<script>
import H2Title from '../../text/twoLevelTitle';

export default {
    name: 'de-text-trend',
    components: {
        H2Title
    },
    props: {
        title: {
            type: String,
            default: '二级标题'
        },
        titlePaddingLeft: {
            type: Number
        },
        titleLineHeight: {
            type: Number
        },
        titleFontObj: {
            type: Object
        },
        sum: {
            type: Number,
            default: 321412
        },
        sumFont: {
            type: Number
        },
        margin: {
            type: Number
        },
        percent: {
            type: Number,
            default: 0
        },
        isActive: {
            type: Boolean,
            default: false
        },
        percentFont: {
            type: Number,
            default: 16
        },
    },
    computed: {
        sumStyleObj() {
            return this.sumFont
            ? (Object.assign({}, {
                fontSize: `${this.sumFont}px`
            }))
            : {};
        },
        arrowSrc() {
            const {isActive, bgObj} = this;
            if (isActive) {
                this.numColor = '#fff';
                return bgObj.active;
            }
            if (this.percent >= 0) {
                this.numColor = '#13FF26';
                return bgObj.up;
            } else {
                this.numColor = '#FF1368';
                return bgObj.down;
            }
        },
        selfArrowStyle() {
            return {
                backgroundImage: `url(${this.arrowSrc})`,
                backgroundRepeat: 'no-repeat',
                width: `${this.percentFont}px`,
                height: `${this.percentFont}px`,
                marginLeft: this.margin <= 0 ? '0px' : `${this.margin}px`,
                marginRight: (this.margin-6) <= 0 ? '0px' : `${this.margin-6}px`,
            }
        },
        selfPercentStyle() {
            return Object.assign({
                color: this.numColor,
                fontSize: `${this.percentFont}px`
            })
        }
    },
    data() {
        return {
            numColor: '',
            bgObj: {
                up: require('@/runtime-components/assets/images/up_arrow.png'),
                down: require('@/runtime-components/assets/images/down_arrow.png'),
                active: require('@/runtime-components/assets/images/up_white_arrow.png')
            }
        }
    }
}
</script>

<style lang="less" scoped>
.de-arrow-percent {
    .num {
        font-family: 'AgencyFB-Reg';
        font-size: 96px;
        color: #FFFFFF;
        .arrow, .percent {
            color: #13FF26;
        }
        .arrow {
            display: inline-block;
            background: url('~@/runtime-components/assets/images/up_arrow.png') no-repeat;
            background-size: cover;
        }
    }
}
</style>